import React from 'react';
// import HTML from "react-native-render-html";
// import Font from './../Colors';
import { MathJax } from './';
 

const ConverToTextComponent = ({text, isMathType, isBold, fontSize, color, style}) => {
    if(isMathType) {        
        if (
			!text || (text.indexOf('$$') === -1 &&
			text.indexOf('$') === -1 &&
			text.indexOf('\(') === -1 &&
			text.indexOf('\[') === -1)
		)  {
            return(
                <div dangerouslySetInnerHTML={{__html: text}} style={{color: color, fontSize: 18 }}>
                </div>  
            )       
        }

        return (
            <MathJax 
                html={text}
                color={color}
                fontFamily={'Spectral-SemiBold'}
                style={style}
            /> 
        )
    }
    return (
            <div dangerouslySetInnerHTML={{__html: text}} style={{color: color ? color : '#000', fontSize: 18, ...style }}>

            </div>  
    )
}

export default ConverToTextComponent;